import { Component, OnInit, HostListener, ElementRef, ChangeDetectorRef, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-custom-menu',
  templateUrl: './custom-menu.component.html',
  styleUrls: ['./custom-menu.component.scss']
})
export class CustomMenuComponent implements OnInit {

  private static MENU_HEIGHT_DEFAULT = 16;

  @Input() menuLabel: string;
  @Input() subMenus: {label: string; path?: string}[] = [];

  @Output() selectMenu = new EventEmitter();
  @Input() menuHeight: number;

  showSubMenu = false;

  constructor(
    private elem: ElementRef<HTMLElement>,
    private chRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    // menuHeightの設定が無い場合
    if (!this.menuHeight) {
      // 描画後の要素高さを受け取るために、setTimeoutで処理を後ろに回す
      setTimeout(() => {
        // 要素の高さを取得して、メニュー1項目の高さに設定
        this.menuHeight = this.elem.nativeElement.getBoundingClientRect().height;

        // 高さを取得できなかった場合は親要素を見る
        if (!this.menuHeight) {
          console.log(this.elem.nativeElement.parentElement.getBoundingClientRect());
          this.menuHeight = this.elem.nativeElement.parentElement.getBoundingClientRect().height;
        }

        // 自身・親要素どちらからも取得できなかった場合はデフォルト値を使用する
        if (!this.menuHeight) {
          this.menuHeight = CustomMenuComponent.MENU_HEIGHT_DEFAULT;
        }

        // 変更を通知
        this.chRef.detectChanges();
      }, 0);
    }
  }

  /**
   * ホバー開始イベント
   */
  @HostListener('mouseover') onMouseOver() {
    this.showSubMenu = true;
  }

  /**
   * ホバー終了イベント
   */
  @HostListener('mouseout') onMouseOut() {
    this.showSubMenu = false;
  }

  /**
   * メニューの選択
   */
  select(param: {label: string; path?: string}) {
    if (param.path) {
      this.showSubMenu = false;
      this.selectMenu.emit(param);
    }
  }
}
